module.exports = __webpack_public_path__ + "img/icon-group-lights.e1c60001.svg";